<div [formGroup]="formComponent" class="grid-x">
  <div class="cell">
    <label for="name">Name:</label>
    <input id="name" type="text" formControlName="name" required>
  </div>
  @if (name.invalid && (name.dirty || name.touched)) {
    <div class="error-container cell">
      @if (name.errors.required) {
        <small class="error">Name is required.</small>
      }
      @if (name.errors.minlength) {
        <small class="error">Name must be at least 4 characters long.</small>
      }
    </div>
  }
  <div class="cell">
    <label for="allowEdit">
      Allow Edits?
      <input id="allowEdit" type="checkbox" formControlName="allowEdit" [value]="allowEdit" />
    </label>
  </div>
  <div class="cell">
    <label for="name">Display Name:</label>
    <input id="displayName" type="text" formControlName="displayName">
  </div>
  <div class="cell">
    <label for="format">Format:</label>
    <select id="format" formControlName="format">
      <option value="none" [selected]="formComponent.value.format == 'none'">None</option>
      <option value="date-time" [selected]="formComponent.value.format == 'date-time'">DateTime</option>
      <option value="date" [selected]="formComponent.value.format == 'date'">Date</option>
      <option value="time" [selected]="formComponent.value.format == 'time'">Time</option>
      <option value="email" [selected]="formComponent.value.format == 'email'">Email</option>
      <option value="uri" [selected]="formComponent.value.format == 'uri'">URL</option>
    </select>
  </div>
  <div class="cell">
    <label for="isOrganizationId">
      Is a reference to an OrganizationId?
      <input id="isOrganizationId" type="checkbox" formControlName="isOrganizationId" [value]="isOrganizationId" />
    </label>
  </div>
</div>